import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../components/Layout.vue'),
  },
  {
    path: '/deep-link',
    name: 'DeepLink',
    component: () => import('../components/Layout.vue'),
    children: [
      {
        path: ':platform/:navigatePath',
        name: 'Mobile',
        component: () => import('../views/Mobile.vue'),
      },
      {
        path: ':platform/:navigatePath',
        name: 'Desktop',
        component: () => import('../views/Desktop.vue'),
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to) => {
  document.title = to.meta.title || 'thelivingos';
});

export default router
